// src/pages/NotFound.jsx
import { useTranslation } from "react-i18next";
import LocalizedLink from "../components/LocalizedLink";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto max-w-3xl px-4 py-24 text-center">
      <div className="inline-flex items-center justify-center rounded-2xl border border-slate-200 bg-white px-6 py-4 shadow-sm">
        <span className="text-2xl font-extrabold text-indigo-600">404</span>
        <span className="mx-3 h-6 w-px bg-slate-200" />
        <span className="text-slate-700 font-medium">{t("notFound.title")}</span>
      </div>

      <p className="mt-6 text-slate-600">{t("notFound.desc")}</p>

      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <LocalizedLink
          to="/"
          className="rounded-xl bg-indigo-600 px-5 py-3 text-white font-medium hover:bg-indigo-700"
        >
          {t("notFound.go_home")}
        </LocalizedLink>
        <LocalizedLink
          to="/projects"
          className="rounded-xl border border-slate-300 px-5 py-3 font-medium hover:bg-slate-50"
        >
          {t("notFound.see_projects")}
        </LocalizedLink>
      </div>
    </section>
  );
}
